import {TransAccount} from "@/common/dto/TransAccount";

export interface BillingAccountSummary {
  account: TransAccount;
  amounts: BillingSummary;
}

export class BillingSummary {
  static zero(): BillingSummary {
    return new BillingSummary(0, 0, 0);
  }

  constructor(
    public readonly carry: number,
    public readonly inAmount: number,
    public readonly outAmount: number
  ) {}

  get balance(): number {
    return this.carry + this.increment;
  }

  get increment(): number {
    return this.inAmount - this.outAmount;
  }

  isMeaningful(): boolean {
    return this.balance !== 0 || this.inAmount !== 0 || this.outAmount !== 0;
  }

  add(other: BillingSummary): BillingSummary {
    return new BillingSummary(
      this.carry + other.carry,
      this.inAmount + other.inAmount,
      this.outAmount + other.outAmount
    );
  }

  subtract(other: BillingSummary): BillingSummary {
    return new BillingSummary(
      this.carry - other.carry,
      this.inAmount - other.inAmount,
      this.outAmount - other.outAmount
    );
  }
}
